var React = require('react');

function Node (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"98.98","cy":"28.77","r":"18.02","key":0}),React.createElement("circle",{"cx":"98.98","cy":"99.73","r":"18.02","key":1}),React.createElement("circle",{"cx":"28.02","cy":"63.7","r":"18.02","key":2}),React.createElement("line",{"x1":"82.63","y1":"38.47","x2":"46.04","y2":"56.77","key":3}),React.createElement("line",{"x1":"80.41","y1":"92.8","x2":"43.82","y2":"74.51","key":4})]);
}

Node.defaultProps = {"className":"svg-node","viewBox":"0 0 128 128","stroke":"#000000","fill":"none"};

module.exports = Node;

Node.default = Node;
